import {
  RECEIVE_GET_COUNTRIES_ERROR,
  REQUEST_GET_COUNTRIES,
  RECEIVE_GET_COUNTRIES,
} from '../constants/parameters';

const DEFAULT_COUNTRY_CODE = "USA";

const defaultState = {
  countries: [],
  defaultCountry: null,
  country: { },
  error: null,
  isFetching: false,
  isFetchingSingle: false,
  isSaving: false,
};

export const countries = (state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_GET_COUNTRIES:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_GET_COUNTRIES: {
      const list = action.countries;
      const record = list.find(c => c.code === DEFAULT_COUNTRY_CODE);
      return {
        ...state,
        countries: list,
        defaultCountry: record
          ? { countryId: record.parameterId, countryName: record.name, countryIsoCode: record.code }
          : null,
        isFetching: false,
      };
    }
    case RECEIVE_GET_COUNTRIES_ERROR:
      return {
        ...state,
        error: action.error,
        isFetching: false,
        isSaving: false,
        isFetchingSingle: false,
      };
    default:
      return state;
  }
};
